
<template>
      <div class="container mx-auto flex flex-col h-screen items-center justify-center bg-neutral-300">
    
        <div class="flex flex-col md:flex-row">
    
          <!-- Image -->

          <div id="image" class="mx-auto mb-4 rounded-full h-48 md:h-64 lg:h-72 w-auto md:w-64 lg:w-72">
    
            <!-- <img alt="David Image" src="../assets/davie.jpg"> -->

          </div>
    
          <!-- Text -->
          <div class="">
    
            <h1 class="text-3xl font-bold">Hello, {{ name }}</h1>
    
            <p class="text-gray-700 text-lg mt-2">Welcome to My Portfolio. I'm excited to show you my work.</p>
    
          </div>
    
        </div>
    
      </div>
    
    </template>
    
    <script>
    
    export default {
    
      data() {
    
        return {
    
          name: " I'am David Wanjohi" ,
    
        };
    
      },
    
    };
    </script>
    
    <style scoped>
    
    .container {
    
      padding: 50px;
    
    }
    
    img {
    
      border: 4px solid #fff;
    
    }
    
    h1 {
      color: #333;
    }
    
    p {
      color: #666;
    }
    #image {
    
      /* background-image: url('/src/assets/img.jpg'); */
    
    }
    </style>
    